/**
 * Should be used instead of Mui's `styled` function second parameter with manual props excluding.
 *
 * @example
 * ````
 *  styled(Paper, { shouldForwardProp: (prop) => prop !== 'disabled' && prop !== 'transition' })({...})
 * ````
 * could be replaced with
 * ````
 *  styled(Paper, shouldNotForwardProps('disabled', 'transition'))({...})
 * ````
 *
 * // TODO: use only Generic version
 * Should be used like
 * ````
 *  styled(Paper, shouldNotForwardProps<PaperOwnProps>('disabled', 'transition'))({...})
 * ````
 * @param args
 * @returns
 */
export function shouldNotForwardProps(
// TODO: future variant:
// export function shouldNotForwardProps<T>(...args: PropertyOf<T>[]): { shouldForwardProp: (propName: PropertyOf<T>) => boolean } {
...args) {
    return {
        shouldForwardProp: (prop) => !args.includes(prop),
    };
}
